import { render, staticRenderFns } from "./alo-ai-user-selector.vue?vue&type=template&id=a2d9b580"
import script from "./alo-ai-user-selector.vue?vue&type=script&lang=js"
export * from "./alo-ai-user-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports